import updateLabels from "../../wizard/scripts/updateName";
import syncWeightInputs from '../../wizard/scripts/updateWeight';

const wrapper = document.querySelector('.wizard-page__edit-info');
const infoBoxes = document.querySelectorAll('.wizard-update-info__box');

if (!wrapper || !infoBoxes) return;

let dogName;
let currentDogData;
let metafield;
let skioData;
let subscriptionPlanId;
let originalBoxContent = [];

//product mapping Shopify - Skio
let mappedData = [
  {
    "variantId": "3212125b-ed4f-4438-ad14-a72def971d6c",
    "platformId": "45632606339358"
  },
  {
    "variantId": "421693f3-cf68-4ddd-a0b6-bab12f45d0ae",
    "platformId": "48570888093982"
  },
  {
    "variantId": "332698da-68ca-428f-8887-bb255ed033b9",
    "platformId": "48570895139102"
  },
  {
    "variantId": "635f8a91-c7aa-46d8-a5ee-f9f1fac7b4b8",
    "platformId": "48570916110622"
  },
  {
    "variantId": "60cf92e2-d575-4aad-bcd7-751aece82a45",
    "platformId": "45833536733470"
  },
  {
    "variantId": "e305d6fa-fbfc-4040-917c-807bcc61547a",
    "platformId": "47263233999134"
  },
  {
    "variantId": "68c1aba3-3874-46bd-aa7d-48f2ce6ab60b",
    "platformId": "48570899202334"
  },
  {
    "variantId": "4308d2e2-cf09-44f3-b1e7-9ab322299862",
    "platformId": "45836361564446"
  },
  {
    "variantId": "f2bbd124-175e-46b7-ae2d-237e68d684db",
    "platformId": "47972154179870"
  },
  {
    "variantId": "91365c53-5098-4d23-9649-cd3bf05f703e",
    "platformId": "45836339380510"
  },
  {
    "variantId": "42593ee0-d431-4934-973e-d3ab7d065202",
    "platformId": "45836314411294"
  },
  {
    "variantId": "e027fd1b-8e85-4ea2-afd1-c96db65fa382",
    "platformId": "45836328599838"
  }
];

function populateOldPlanProducts(skioData) {
  let subscriptionLines = skioData.SubscriptionLines;
  subscriptionPlanId = skioData.id;
  let displayWrapper = document.querySelector('.wizard-recommendation__block-old');

  subscriptionLines.forEach(subscriptionLine => {
    let variantId = subscriptionLine.ProductVariant.platformId;
    variantId = variantId.split('/').pop();
    let quantity = subscriptionLine.quantity;
    originalBoxContent.push({
      "variantId": subscriptionLine.ProductVariant.id,
      quantity,
      "platformId": variantId
    })

    displayWrapper.querySelector(`[data-variant-id="${variantId}"]`)?.classList.add('is-selected');
    displayWrapper.querySelector(`[data-variant-id="${variantId}"] .wizard-product-card__info-title`)?.prepend(quantity + " x ");

  });

  // Iterate through the mappedData array
  mappedData.forEach(({ variantId, platformId }) => {
    // Query all DOM elements with the data-variant-id attribute equal to the platformId
    const elements = document.querySelectorAll(`[data-variant-id="${platformId}"]`);

    // Loop through all matched elements and set the new data attribute
    elements.forEach(element => {
      element.setAttribute("data-subscription-line-item-id", variantId);
    });
  });
}


function getCurrentSubscriptionInfo(dogName, customer) {
  const store = '974fe1';
  const url = `https://netlify.blacklemon.dk/.netlify/functions/getSkioSubscriptions?customer=${customer}&dogName=${dogName}`;

  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(res => {
      if (res.error) {
        console.log('We have an error:', res.error);
      } else {
        skioData = res.message;
        populateOldPlanProducts(skioData);
      }
    })
    .catch(err => {
      console.error('Fetch error:', err);
    });
}

let active_dog_name;
let active_dog_new_age;
let dogs_age = [];

//populate inital boxes with dog data
function populateInfoBoxes() {
  quizDataForDogs.forEach((dogData, index) => {
    let dogInfoBox = document.querySelector(`.wizard-update-info__box-${index}`);

    dogs_age.push({
      dog_name: dogData.name,
      dog_months: dogData.years * 12 + dogData.months
    })

    dogInfoBox.querySelector('.navigation__button').addEventListener('click', function (event) {
      metafield = event.target.dataset.metafield;
      if (metafield) {
        dogName = dogData.name;
        active_dog_name = dogName;
        currentDogData = quizDataForDogs.find(obj => obj.name === dogName);
        populateQuizAnswers(currentDogData);
        updateLabels(dogName);

        getCurrentSubscriptionInfo(dogName, customerEmail);

        document.querySelector('.wizard-update-info').style.display = "none";
        document.querySelector('.wizard-update-form').style.display = "block";
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

    //button label
    dogInfoBox.querySelector('.navigation__button .replace-dog-name').innerHTML = dogData.name;

    // gender check and spayed check TODO
    let gender = dogData.gender;
    let neutered = dogData.neutered;

    if (gender == "Boy") {
      if (neutered == "Yes") {
        dogInfoBox.querySelector('.dog_spayed').innerHTML = "Neutered";
      } else {
        dogInfoBox.querySelector('.dog_spayed').innerHTML = "Not neutered";
      }
    } else {
      if (neutered == "Yes") {
        dogInfoBox.querySelector('.dog_spayed').innerHTML = "Spayed";
      } else {
        dogInfoBox.querySelector('.dog_spayed').innerHTML = "Not spayed";
      }
    }


    //weight
    dogInfoBox.querySelector('.dog_weight').innerHTML = dogData.weight + "kg";

    //weightgroup
    dogInfoBox.querySelector('.dog_bodytype').innerHTML = document.querySelector(`input[name="weightgroup"][value="${dogData.weightgroup}"] + .choice-illustration__wrapper .choice-illustration__text span`).innerHTML;

    //activity
    dogInfoBox.querySelector('.dog_activity').innerHTML = document.querySelector(`input[name="activity"][value="${dogData.activity}"] + .choice-illustration__wrapper .choice-illustration__text span`).innerHTML;

    //allergies
    dogInfoBox.querySelector('.dog_allergies').innerHTML = (dogData.allergies == "nothing" || dogData.allergies == "") ? "No allergies" : `Allergic to ${dogData.allergies.join(", ")}`;

    //health issues
    dogInfoBox.querySelector('.dog_health_issues').innerHTML = dogData.health_issues == "No health issues" ? "No health issues" : `${dogData.health_issues.join(", ")}`;
  });
}

//populate info boxes with all dog data
populateInfoBoxes();

//age input fields logic
const ageGroupRadios = document.querySelectorAll('input[name="age_group"]');
const inputYears = document.querySelector('input[name="years"]');
const inputMonths = document.querySelector('input[name="months"]');
const inputYearsContainer = document.getElementById("input_age_years");

function toggleInputs() {
  const selectedAgeGroup = document.querySelector('input[name="age_group"]:checked').value;

  if (selectedAgeGroup === "Puppy") {
    // Show only Months input, hide Years input
    inputYearsContainer.style.display = "none";
    inputMonths.parentElement.style.display = "block";
    inputMonths.setAttribute("required", "required"); // Make Months mandatory
    inputYears.removeAttribute("required");
    inputYears.value = ""; // Clear Years input if not needed
    inputYears.dispatchEvent(new Event('change'));
  } else {
    // Show both inputs but make Years input mandatory
    inputYearsContainer.style.display = "block";
    inputMonths.parentElement.style.display = "block";
    inputYears.setAttribute("required", "required");
    inputMonths.removeAttribute("required"); // Months optional
    inputMonths.dispatchEvent(new Event('change'));
    //inputMonths.value = ""; // Clear Months input if not needed
  }
}

// Event listener for age group radio buttons
ageGroupRadios.forEach((radio) =>
  radio.addEventListener("change", toggleInputs)
);





function populateQuizAnswers(currentDogData) {

  //update spayed/neutered label by gender
  let gender = currentDogData.gender;
  let label = document.getElementById('neutered-spayed');
  let old = label.innerHTML;
  label.innerHTML = (gender == 'Boy') ? old.replace('Spayed', 'Neutered') : old.replace('Neutered', 'Spayed');

  // fill quiz data values

  //age
  let months = (currentDogData.months) ? currentDogData.months : 0;
  let years = (currentDogData.years) ? currentDogData.years : 0;
  document.querySelector(`input[name="months"]`).value = months;
  document.querySelector(`input[name="years"]`).value = years;

  let totalMonths = (years * 12) + months;

  if (totalMonths > 84) {
    document.querySelector(`input[name="age_group"][value="Senior"]`).checked = true;
    document.querySelector(`input[name="age_group"][value="Adult"]`).disabled = true;
    document.querySelector(`input[name="age_group"][value="Puppy"]`).disabled = true;
    toggleInputs();
  } else if (totalMonths < 12) {
    document.querySelector(`input[name="age_group"][value="Puppy"]`).checked = true;
    toggleInputs();
  } else {
    document.querySelector(`input[name="age_group"][value="Adult"]`).checked = true;
    document.querySelector(`input[name="age_group"][value="Puppy"]`).disabled = true;
    toggleInputs();
  }


  //weight
  let weight = currentDogData.weight;
  document.getElementById('weightTextInput').value = weight;
  document.getElementById('weightRangeInput').value = weight;
  syncWeightInputs('weightTextInput', 'weightRangeInput');

  //spayed/neutered
  let spayed = currentDogData.neutered;
  document.querySelector(`input[name="neutered"][value="${spayed}"]`).checked = true;

  //bodytype
  let weightgroup = currentDogData.weightgroup;
  document.querySelector(`input[name="weightgroup"][value="${weightgroup}"]`).checked = true;

  //activity
  let activity = currentDogData.weightgroup;
  document.querySelector(`input[name="activity"][value="${activity}"]`).checked = true;

  //allergies
  let allergies = currentDogData.allergies;
  allergies.forEach((allergy, index) => {
    let capitalizedText = allergy.charAt(0).toUpperCase() + allergy.slice(1);
    document.querySelector(`input[name="allergies"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
  });

  //treats
  let treats = currentDogData.treats;
  document.querySelector(`input[name="treats"][value="${treats}"]`).checked = true;

  //health issues
  let healthIssues = currentDogData.health_issues;
  healthIssues.forEach((healthIssue, index) => {
    let capitalizedText = healthIssue.charAt(0).toUpperCase() + healthIssue.slice(1);
    document.querySelector(`input[name="health_issues"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
  });


  const allCheckboxesAllergies = document.querySelectorAll("input[name='allergies']");

  allCheckboxesAllergies.forEach(input => {
    input.addEventListener('click', function () {
      if (this.value == 'Nothing') {
        if (this.checked) {
          allCheckboxesAllergies.forEach(item => {
            if (item.value == 'Nothing') { return; }
            item.checked = false;
          });
        }
      } else {
        document.querySelector('input[name="allergies"][value="Nothing"]').checked = false;
      }
    });
  });


  const allCheckboxesHealth = document.querySelectorAll("input[name='health_issues']");

  allCheckboxesHealth.forEach(input => {
    input.addEventListener('click', function () {
      if (this.value == 'No health issues') {
        if (this.checked) {
          allCheckboxesHealth.forEach(item => {
            if (item.value == 'No health issues') { return; }
            item.checked = false;
          });
        }
      } else {
        document.querySelector('input[name="health_issues"][value="No health issues"]').checked = false;
      }
    });
  });




  const allCheckboxesTreats = document.querySelectorAll("input[name='prefered_treat']");

  allCheckboxesTreats.forEach(input => {
    input.addEventListener('click', function () {
      if (this.value == 'none') {
        if (this.checked) {
          allCheckboxesTreats.forEach(item => {
            if (item.value == 'none') { return; }
            item.checked = false;
          });
        }
      } else {
        document.querySelector('input[name="prefered_treat"][value="none"]').checked = false;
      }
    });
  });

}



// Get input values
function qiv(name) {
  var element = document.querySelector('form input[name="' + name + '"]');
  return (element || element === 0) ? element.value : false;
}

// Get age values
function ageInput(type) {
  if (type == 'years') { return parseInt(qiv('years')) || 0; }
  if (type == 'months') { return parseInt(qiv('months')) || 0; }
  //if (type == 'birthday') { return (inputType == 'manual') ? false : qiv('datepicker__input'); }
}


//get all inputs
//create new data object

function newData() {
  //clone initial data
  let data = Object.assign({}, currentDogData);

  //update required values
  data.years = ageInput('years');
  data.months = ageInput('months');
  data.weight = parseFloat(qiv('weight'))
  data.neutered = document.querySelector('form input[name="neutered"]:checked').value;
  data.weightgroup = parseInt(document.querySelector('input[name="weightgroup"]:checked').value);
  data.activity = parseInt(document.querySelector('input[name="activity"]:checked').value);
  data.allergies = Array.from(document.querySelectorAll('form input[name="allergies"]:checked')).map(el => el.value.toLowerCase());
  data.treats = parseInt(document.querySelector('input[name="treats"]:checked').value)
  data.health_issues = Array.from(document.querySelectorAll('form input[name="health_issues"]:checked')).map(el => el.value.toLowerCase());

  //change global value
  active_dog_new_age = data.years * 12 + data.months;

  return data;
}

document.querySelector('.calculate-plan').addEventListener('click', function () {
  //display old data calculation
  calculateMealPlan(JSON.stringify(currentDogData), 'old');
  //display old data calculation
  calculateMealPlan(JSON.stringify(newData()), 'new');
  //handle step dsplay logic
  document.querySelector('.wizard-update-form').style.display = "none";
  document.querySelector('.wizard-recommendation').style.display = "block";
  window.scrollTo({ top: 0, behavior: 'smooth' });
});


function updatePuppyInfo() {
  // Find the dog with the specified name and update its months
  const dog = dogs_age.find(dog => dog.dog_name === active_dog_name);
  if (dog) {
    dog.dog_months = active_dog_new_age;
  } else {
    console.log("Dog not found");
  }

  // Check if any dog has dog_months greater than 11
  if (dogs_age.some(dog => dog.dog_months <= 11)) {
    console.log("At least one dog has less than 11 months!");
  } else {
    //set custom property to false
    const email = customerEmail; // Email of the customer
    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      body: `{"data":{"type":"profile","attributes":{"properties":{"hasPuppy":false},"email":"${email}"}}}`
    };

    fetch('https://a.klaviyo.com/client/profiles?company_id=R6vSRF', options)
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(err => console.error(err));

  }
}



function updateCustomerMetafield(quiz, customer, metafield) {
  const store = '974fe1';
  const url = `https://netlify.blacklemon.dk/.netlify/functions/updateCustomerMetafield?store=${store}&customer=${customer}&metafield=${metafield}`;

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(quiz)
  })
    .then(response => {
      if (!response.ok) {
        document.querySelector('.update-plan__error-message').style.display = "block";
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(res => {
      if (res.error) {
        console.log('We have an error:', res.error);
        document.querySelector('.update-plan__error-message').style.display = "block";
      } else {
        console.log('Success:', res);
        document.querySelector('.wizard-recommendation__blocks').style.display = "none";
        document.querySelector('.navigation__button.update-plan').style.display = "none";
        document.querySelector('.update-plan__success-message').classList.add('plan-updated');
        updatePuppyInfo();
      }
    })
    .catch(err => {
      console.error('Fetch error:', err);
    });
}






document.querySelector('.update-plan').addEventListener('click', function () {
  document.querySelector('.update-plan').classList.add('is-loading');
  updateNewPlanInSkio(newProducts);
});

















let feedingGuide;

function feedingGuideCalc(mealCount) {
  // Calculate y as x divided by 28
  const packPercentage = mealCount / 28;

  // If y is less than 0.25, set it to 0.25
  if (packPercentage < 0.25) {
    return 0.25;
  }

  // Round y to the nearest 0.25
  const roundedpackPercentage = Math.round(packPercentage * 4) / 4;

  return roundedpackPercentage;
}

// Default package split
let split = {
  chicken: 0.35,
  lamb: 0.2,
  beef: 0.3,
  salmon: 0.15,
};

// Function to increase split percentages if the total is less than 1
function adjustSplitPercentage(split) {
  const totalSplit = Object.values(split).reduce((acc, val) => acc + val, 0);

  if (totalSplit < 1) {
    const diff = 1 - totalSplit;
    const count = Object.keys(split).length;

    for (const key in split) {
      split[key] += diff / count;
    }
  }

  return split;
}

function sanitizeBolean(value) {
  value = value.trim();
  switch (value.toLowerCase()) {
    case 'yes':
      return true;
    case 'no':
      return false;
    default:
      return Boolean(value);
  }
}

// Remove ingredients if allergic
function removeAllergicIngredients(subscriptionData) {
  subscriptionData.dog_allergies.forEach(allergy => {
    delete split[allergy.toLowerCase()];
  });

  split = adjustSplitPercentage(split);

  return split;
}

function mealDistribution(split, monthlyCartons) {
  let foodPackage = {
    'chicken': split['chicken'] ? Math.round(monthlyCartons * split['chicken']) : 0,
    'lamb': split['lamb'] ? Math.round(monthlyCartons * split['lamb']) : 0,
    'beef': split['beef'] ? Math.round(monthlyCartons * split['beef']) : 0,
    'salmon': split['salmon'] ? Math.round(monthlyCartons * split['salmon']) : 0
  };

  // Increase package until monthly target is met
  let difference = Math.round(monthlyCartons - Object.values(foodPackage).reduce((a, b) => a + b, 0));
  while (difference > 0) {
    for (let type in foodPackage) {
      if (difference > 0 && split.hasOwnProperty(type)) {
        foodPackage[type] += 1;
        difference -= 1;
      }
    }
  }

  return foodPackage;
}


let newProducts = [];

function calculateMealPlan(payload, plan) {

  let payloadData = JSON.parse(payload);
  let fullPrice = 0;
  let fullPlanPrice = 0;

  const wpDays = 28;

  let subscriptionData = {
    "dog_name": payloadData.name,
    "dog_breed": payloadData.breed,
    "dog_gender": payloadData.gender,
    "dog_neutered": sanitizeBolean(payloadData.neutered),
    "dog_years": payloadData.years,
    "dog_months": payloadData.months,
    "dog_weight": payloadData.weight,
    "dog_weightgroup": payloadData.weightgroup,
    "dog_activity": payloadData.activity,
    "dog_treats": payloadData.treats,
    "dog_allergies": payloadData.allergies,
    "dog_eating": payloadData.food,
    "dog_fussy_dog": sanitizeBolean(payloadData.fussy_dog),
    "dog_prefered_treat": payloadData.prefered_treat,
    "dog_health_issues": payloadData.health_issues,
  }

  if (plan == "new") {
    removeAllergicIngredients(subscriptionData);
  }

  // Calculate age in months
  let months;
  months = (subscriptionData['dog_years'] * 12) + subscriptionData['dog_months'];

  // Get multiplier
  let multiplier;
  if (months < 6) {
    multiplier = 1.8;
  } else if (months < 9) {
    multiplier = 1.6;
  } else if (months < 12) {
    multiplier = 1.4;
  } else {
    multiplier = 1.2;
  }

  // Adjust multiplier by activity
  if (months >= 12) {
    multiplier -= (subscriptionData['dog_activity'] < 2) ? 0.1 : 0; // Inactive
    multiplier += (subscriptionData['dog_activity'] > 2) ? 0.1 : 0; // Very active
  }

  // Adjust multiplier by weight group
  if (months < 12) {
    // Puppy
    multiplier *= (subscriptionData['dog_weightgroup'] < 2) ? 1.1 : 1; // Underweight
  } else {
    // Adult
    multiplier *= (subscriptionData['dog_weightgroup'] < 2) ? 1.1 : 1; // Underweight
    multiplier *= (subscriptionData['dog_weightgroup'] > 2) ? 0.9 : 1; // Overweight
  }

  // Adjust multiplier if neutered
  multiplier *= (subscriptionData['dog_neutered'] && months >= 6) ? 0.9 : 1;

  // Treats to multiplier
  const treats = 1 - ((subscriptionData['dog_treats'] - 1) * 0.05);

  let percentage = 100;

  // Calculate calorie requirement
  const RER = 70 * Math.pow(subscriptionData['dog_weight'], 0.75);
  const MER = (RER * multiplier) * treats;
  const MERReduced = MER * (percentage / 100);

  // Daily & monthly dinings/cartons
  const dailyDinings = Math.round(MERReduced / 125); // Round to nearest integer
  const dailyCartons = dailyDinings / 4; // Convert to quarters
  monthlyCartons = dailyCartons * wpDays; // Multiply by wpDays

  let foodPackage = mealDistribution(split, monthlyCartons);

  /* dog treats */
  let preferedTreat = {};
  if (subscriptionData['dog_treats'] > 1) {
    let treatList = [
      "lamb",
      "chicken",
      "beef"
    ];

    if (subscriptionData['dog_prefered_treat'] == 'none') {
      subscriptionData.dog_allergies.forEach(allergy => {
        // Find the index of the allergy in the treatList
        const index = treatList.indexOf(allergy.toLowerCase());
        // If the allergy is in treatList, remove it
        if (index !== -1) {
          treatList.splice(index, 1); // Remove the item at the found index
        }
      });

      if (treatList.length) {
        //select first from list (predefined order)
        let objKey = treatList[0];
        preferedTreat[objKey] = 1
      } else {
        preferedTreat = "no treats";
      }
    } else {
      // 1 product per chosen flavour
      if (Array.isArray(subscriptionData['dog_prefered_treat'])) {
        subscriptionData['dog_prefered_treat'].forEach((item) => {
          preferedTreat[item] = 1;
        });
      } else if (subscriptionData['dog_prefered_treat']) {
        preferedTreat[subscriptionData['dog_prefered_treat']] = 1;
      }
    }

  }


  /* dog supplements */
  let supplements = {};
  let supplementsQuantity = 1;

  // function calculateAdditions(weight) {
  //     if (weight < 10) {
  //         return 1;
  //     } else if (weight <= 25) {
  //         return 2;
  //     } else if (weight <= 40) {
  //         return 3;
  //     } else {
  //         // Calculate additional additions for weights above 40kg
  //         const extraWeight = weight - 40;
  //         const extraAdditions = Math.ceil(extraWeight / 15);
  //         return 3 + extraAdditions;
  //     }
  // }


  if (months >= 6) {

    if (subscriptionData['dog_health_issues'].includes('dry, itchy or dull coat')) {
      supplements.oil = supplementsQuantity; // Add "oil" supplement
    }

    if (subscriptionData['dog_health_issues'].includes('a sensitive stomach')) {
      supplements.gut = supplementsQuantity; // Add "gut" supplement
    }

    if (subscriptionData['dog_health_issues'].includes('dental issues or bad breath')) {
      supplements.dental = supplementsQuantity; // Add "dental" supplement
    }

    if (subscriptionData['dog_health_issues'].includes('joint stiffness or pain')) {
      supplements.joint = supplementsQuantity; // Add "joint" supplement
    }

  }

  let totalPackage = {
    foodPackage,
    preferedTreat,
    supplements
  };

  //get quantites from api
  let response = totalPackage;
  const cartQuantites = {};


  /* MEALS */
  //match quantites with products
  for (const product of productList) {
    for (const [key, value] of Object.entries(response.foodPackage)) {
      if (product.title.toLowerCase().includes(key)) {
        cartQuantites[product.variants[0].id] = value;
        fullPrice += product.price * value;
        break;
      }
    }
  }
  fullPlanPrice += fullPrice * 2;


  const mealTotalCount = Object.values(response.foodPackage).reduce((sum, value) => sum + value, 0);
  feedingGuide = feedingGuideCalc(mealTotalCount);

  document.getElementById(`packs-per-day-${plan}`).innerHTML = feedingGuide;

  const mealFoodIncluded = Object.keys(response.foodPackage)
    .filter(key => response.foodPackage[key] !== 0)
    .join(', ');

  $('.meal-portions').html(mealTotalCount);
  $('.meal-portions-full').html(mealTotalCount * 2);
  $('.meal-contains').html(mealFoodIncluded);



  /* TREATS */
  let prefferedTreats = preferedTreat;

  if (Object.keys(prefferedTreats).length > 0) {

    const mealFoodIncluded = Object.keys(prefferedTreats)
      .filter(key => response.preferedTreat[key] !== 0)
      .join(', ');

    for (const treat of treatsList) {
      for (const [key, value] of Object.entries(prefferedTreats)) {
        if (treat.title.toLowerCase().includes(key)) {
          cartQuantites[treat.variants[0].id] = value;
          fullPrice += treat.price * value;
          fullPlanPrice += treat.price * value;
        }
      }

      $('.treat-contains').html(mealFoodIncluded);
      $('.treat-count').html(Object.keys(prefferedTreats).length);

    }
  } else {
    $('details[data-plan-type="treats"]').hide();
  }

  /* SUPPLEMENTS */
  let supplementsCalc = response.supplements;
  if (supplementsCalc && months >= 6) {
    for (const supplement of supplementList) {
      for (const [key, value] of Object.entries(supplementsCalc)) {
        if (supplement.title.toLowerCase().includes(key)) {
          cartQuantites[supplement.variants[0].id] = value;
          fullPrice += supplement.price * value;
          fullPlanPrice += supplement.price * value
          break;
        }
      }
    }


    const supplementsCount = Object.values(supplementsCalc).reduce((acc, value) => acc + value, 0);
    const supplementIncluded = Object.keys(response.supplements)
      .filter(key => response.supplements[key] !== 0)
      .join(', ');


    $('.supplements-quantity').html(supplementsCount);
    $('.supplements-contains').html(supplementIncluded);
  } else {
    $('details[data-plan-type="supplements"]').hide();
  }

  cartObject = cartQuantites;

  if (plan == "new") {

    // Get all elements with the class 'wizard-product-card'
    const productCards = document.querySelectorAll(`.wizard-recommendation__block-${plan} .wizard-product-card`);

    // Iterate over the elements and check if 'data-variant-id' is in the object
    productCards.forEach(card => {
      const variantId = card.getAttribute('data-variant-id');

      if (cartObject.hasOwnProperty(variantId) && cartObject[variantId] !== 0) {
        card.classList.add('is-selected');
        card.querySelector('.wizard-product-card__info-title').prepend(cartObject[variantId] + " x ");

        // Ensure the element exists before accessing properties
        const trialPlanBox = card.closest('.plan-box__summary-cards');
        if (trialPlanBox) {
          card.querySelector('span').innerHTML = cartObject[variantId];
        }

        // Find the closest ancestor with class 'plan-box__wrapper--full'
        const wrapper = card.closest('details.type-meals[data-plan-type="meals"]');

        if (wrapper) {
          card.querySelector('span').innerHTML = cartObject[variantId] * 2;
        }

      }

      //if item has no quantity, make it 0 so it can be removed form subscription
      let quantity = cartObject[variantId] ? cartObject[variantId] : 0;
      let subscriptionLineItemId = card.dataset.subscriptionLineItemId;
      newProducts.push({
        "variantId": subscriptionLineItemId,
        quantity
      });
    });
  }

}


function updateNewPlanInSkio(newProducts) {
  const store = '974fe1';
  const url = `https://netlify.blacklemon.dk/.netlify/functions/updateSkioSubscriptionProducts?subscriptionPlanId=${subscriptionPlanId}`;

  let payloadContent = {
    "originalBoxContent": originalBoxContent,
    "newBoxContent": newProducts
  };

  const payload = JSON.stringify(payloadContent);

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: payload
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(res => {
      if (res.error) {
        console.log('We have an error:', res.error);
      } else {
        console.log('Success:', res);

        //update metafield     
        let payload = newData();
        updateCustomerMetafield(payload, customer, metafield);
      }
    })
    .catch(err => {
      console.error('Fetch error:', err);
    });
}